import React from "react";

function TextViewMode(props) {
    return (
        <div className="questionaire__builder__question__form questionaire__builder__question__form--flex pv-md">
            <input
                type="text"
                className="questionaire__builder__question__form__input text_view_mode"
            />
        </div>
    )
}

export default TextViewMode;